import { render, staticRenderFns } from "./NoteDetail.vue?vue&type=template&id=0510717a&scoped=true&"
import script from "@/scripts/Notes/NoteDetail/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Notes/NoteDetail/index.js?vue&type=script&lang=js&"
import style0 from "./NoteDetail.vue?vue&type=style&index=0&id=0510717a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0510717a",
  null
  
)

export default component.exports